import React from 'react';
import classnames from 'classnames';

import styles from './LoaderButton.scss';

import Button from './Button';

const LoaderButton = ({
  isLoading,
  text,
  loadingText,
  disabled = false,
  ...props
}) => {
  return (
    <Button disabled={disabled || isLoading} {...props}>
      {isLoading ? loadingText : text}
      {
        isLoading &&
          <i
            className={classnames('fa', 'fa-circle-o-notch', 'fa-spin', styles.icon)}
          />
      }
    </Button>
  );
};

LoaderButton.propTypes = {
  text: React.PropTypes.string,
  isLoading: React.PropTypes.bool,
  loadingText: React.PropTypes.string,
  disabled: React.PropTypes.bool,
};

export default LoaderButton;



// WEBPACK FOOTER //
// ./src/components/button/components/LoaderButton.jsx